import { Get } from "../http/httpVerbs";

export const apiGetFranchisesReport = async (communityId) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/comunidades/${communityId}/franchises/report`;
    const response = await Get(url);
    return response;
  } catch (error) {
    console.error("Error fetching franchises report:", error);
    throw error;
  }
};
